import { chakraCreateIcon } from "@airhelp/react-ui-components";

export const PlayButton = chakraCreateIcon({
  displayName: "PlayButton",
  viewBox: "0 0 112 112",
  path: (
    <>
      <circle opacity="0.2" cx="56" cy="56" r="56" fill="white" />
      <circle cx="56" cy="56" r="48" fill="white" />
      <path
        d="M69 54.2679C70.3333 55.0378 70.3333 56.9622 69 57.7321L51 68.1244C49.6667 68.8942 48 67.9319 48 66.3923L48 45.6077C48 44.0681 49.6667 43.1058 51 43.8756L69 54.2679Z"
        fill="#FF4D56"
      />
    </>
  ),
});
